const courseCRouter = {
  path: '/course',
  component: () => import('@/views/course/detail'),
  hidden: true,
  redirect: '/course/describe',
  name: 'courseIndex',
  children: [

    /*{
      path: '/course/detail',
      component: () => import('@/views/course/detail'),
      name: 'courseDetail'
    },*/
    {
      path: '/course/describe',
      component: () => import('@/views/course/desc'),
      name: 'courseDescribe'
    },
    {
      path: '/course/watch',
      component: () => import('@/views/course/watch'),
      name: 'courseWatch'
    }
  ]

}

export default courseCRouter
